import { SignUp } from "@clerk/clerk-react";
import { Logo } from "@the-drop/ui";

/**
 * Dedicated sign-up route at `/sign-up` (+ splat child for Clerk's internal
 * sub-paths). Shell-level `Sign in` CTA + `SignIn` component's "Sign up"
 * link both route here. `redirect_url` round-trips via the URL query
 * string; `fallbackRedirectUrl` lands new accounts at `/` after creation.
 */
export function SignUpScreen() {
  return (
    <div className="mx-auto w-full max-w-md space-y-6 pt-12 pb-16">
      <div className="space-y-2 text-center">
        <div className="flex justify-center pb-2">
          <Logo size="md" tone="dark" />
        </div>
        <p className="text-[10px] font-semibold uppercase tracking-[.1em] text-[var(--green)]">
          Drop
        </p>
        <h1 className="text-2xl font-bold tracking-tight text-[var(--text-primary)]">
          Create your Drop account
        </h1>
        <p className="text-sm text-[var(--text-secondary)]">
          One account for licensed Denver cannabis delivery.
        </p>
      </div>
      <div className="flex justify-center">
        <SignUp
          routing="path"
          path="/sign-up"
          signInUrl="/sign-in"
          fallbackRedirectUrl="/"
          appearance={{
            variables: {
              colorPrimary: "var(--green)",
              colorText: "var(--text-primary)",
              colorBackground: "var(--card-bg)",
              borderRadius: "0.75rem",
              fontFamily: "Inter, system-ui, sans-serif",
            },
            elements: {
              card: "shadow-cardMd border border-[var(--card-border)]",
              formButtonPrimary:
                "bg-[var(--green)] hover:bg-[var(--green-dark)] text-sm font-semibold",
              footerActionLink: "text-[var(--green)] hover:text-[var(--green-dark)]",
            },
          }}
        />
      </div>
    </div>
  );
}
